<template>
  <div class="check-container">
    <input type="checkbox" :id="id" v-model="checked" />
    <label :for="id" class="checkbox">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Label',
    },

    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },

    id: {
      type: [Object, Number, String],
      default: 'check',
    },
  },

  computed: {
    checked: {
      get() {
        return this.modelValue;
      },

      set(newChecked) {
        this.$emit('update:modelValue', newChecked);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.check-container {
  display: flex;
  align-items: center;
}

label::before {
  vertical-align: text-top !important;
  margin: 0 1rem 0 0 !important;
}
</style>